import { useCallback } from "react";
import { Layout, Tabs } from "@shopify/polaris";

import ChooseAction from "./components/ChooseAction/ChooseAction.js";
import { actionTabs } from "./actionsTabs.js";
import SelectProducts from "./components/SelectProducts/SelectProducts.js";
import TypeAndOptions from "./components/TypeAndOptions/TypeAndOptions.js";
import AdvancedSettings from "./components/AdvancedSettings/AdvancedSettings.js";
import { openModal } from "../../store/features/modal.js";
import { OPEN_MODAL_BACK } from "../../constants/modalTypes.js";
import { useAppDispatch, useAppSelector } from "../../hooks/redux.js";

const actionSteps = [<ChooseAction />, <SelectProducts />, <TypeAndOptions />, <AdvancedSettings />];

const ActionComponent = () => {
  const dispatch = useAppDispatch();
  const action = useAppSelector((state) => state.action);

  const handleOnSelect = useCallback((selectedTabIndex) => {
    if (selectedTabIndex < action.currentStep || action.actionId) {
      dispatch(openModal({ modalType: OPEN_MODAL_BACK, modalData: { backStep: selectedTabIndex } }));
    }
  }, [action.currentStep]);

  return (
    <div className="container">
      <Layout>
        <Layout.Section>
          <Tabs
            fitted
            tabs={actionTabs}
            selected={action.currentStep}
            onSelect={handleOnSelect}
          />
        </Layout.Section>
      </Layout>
      {actionSteps[action.currentStep]}
    </div>
  );
};

export default ActionComponent;